import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable, ErrorHandler } from '@angular/core';
import { KeyValue } from '@angular/common';
import {
  IApiResponse,
  IFilterPaginationDto,
  IRestaurantDto,
  IRestUserMappingDto,
} from '../models';
import { map } from 'rxjs/operators';

@Injectable()
export class RestaurantService extends ApiService {
  public _restaurant$: Observable<KeyValue<number, string>[]> = null;

  constructor(http: HttpClient, errorHandler: ErrorHandler) {
    super(http, errorHandler);
  }

  public getRestaurantList(
    model: IFilterPaginationDto
  ): Observable<IRestaurantDto[]> {
    return this.post(`admin/restaurant/list`, model);
  }

  public getRestaurantNames(): Observable<KeyValue<number, string>[]> {
    if (this._restaurant$ == null) {
      this._restaurant$ = this.get(`admin/restaurant`).pipe(
        map((val) => {
          return val.map((v: KeyValue<number, string>) => {
            return {
              key: v.key,
              value: v.value,
            };
          });
        })
      );
    }
    return this._restaurant$;
  }

  // public getRestaurantNames(): Observable<KeyValue<number, string>[]> {
  //   return this.get(`admin/restaurant`);
  // }

  public getRestaurant(id: number): Observable<IRestaurantDto> {
    return this.get(`admin/restaurant/${id}`);
  }

  public saveRestaurant(
    model: IRestaurantDto
  ): Observable<IApiResponse<boolean>> {
    return this.post(`admin/restaurant`, model);
  }

  public changeRestaurantStatus(id: number): Observable<IApiResponse<boolean>> {
    return this.put(`admin/restaurant/${id}`, null);
  }

  public getRestaurantAssignmentList(
    id: number,
    model: IFilterPaginationDto
  ): Observable<IRestUserMappingDto[]> {
    return this.post(`admin/restaurant/assignmentList/${id}`, model);
  }

  public getRestaurantAssignment(id: number): Observable<IRestUserMappingDto> {
    return this.get(`admin/restaurant/assignment/${id}`);
  }

  public saveRestaurantAssignment(
    id: number,
    model: IRestUserMappingDto[]
  ): Observable<IApiResponse<boolean>> {
    return this.post(`admin/restaurant/assignment/${id}`, model);
  }

  public deleteRestaurant(id: number): Observable<IApiResponse<boolean>> {
    return this.delete(`admin/restaurant/${id}`);
  }
}
